import React from 'react'
import { Heading } from '@offerzen/pinata-shame'
import styles from './styles'

const MobileSectionDescription = ({ fullTitle, optional }) => (
  <div className={styles.wrapper}>
    <Heading>
      {fullTitle}

      <If condition={optional}>
        <span className={styles.optionalText}> (optional)</span>
      </If>
    </Heading>
  </div>
)

export default MobileSectionDescription
